import { useMutation, useQueryClient } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IProps {
  catalogUid: string;
  isPinned: boolean;
}

export const useToggleCatalogPinQuery = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ catalogUid, isPinned }: IProps) => {
      if (isPinned) {
        return await Api.products.unpinCatalog(catalogUid);
      }

      return await Api.products.pinCatalog(catalogUid);
    },
    onSuccess: async () => {
      await client.invalidateQueries(['getCatalogs']);
      await client.invalidateQueries(['getCatalog']);
    },
  });
};
